/**
 * Bingo scheduler Collection
 */

define(function(require, exports, module) {
    'use strict';

    var BaseCollection = require('common/base.collection');
    var BingoSchedulerItemModel = require('portlets/bingo-scheduler/bingo-scheduler.item.model');

    module.exports = BaseCollection.extend({

        model: BingoSchedulerItemModel

    });
});
